import React from "react";
import { useState, useEffect } from "react";
import { MdLocationPin } from "react-icons/md";
import { AiOutlineTwitter, AiFillLinkedin, AiFillGithub } from "react-icons/ai";
import { BsGlobe } from "react-icons/bs";

import Modal from "../../component/Modal";
import Loader from "../../component/Loader";
import Pagination from "../../component/Pagination";
import { Tab } from "../../component/Tab";

import api from "../../../../services/api";
import IconsLib from "../../lib/icon.json";
import Export from "./export";

export const Users = ({ campaign }) => {
  const [total, setTotal] = useState();
  const [users, setUsers] = useState();
  const [filters, setFilters] = useState({
    page: 0,
    perPage: 20,
    campaignId: campaign._id,
  });

  useEffect(() => {
    (async () => {
      const { data, total: t } = await api.post("/githeo_scrapped_user/search", filters);
      setUsers(data);
      setTotal(t);
    })();
  }, [filters]);

  if (!users) return <Loader />;

  return (
    <>
      <div className="space-y-6">
        <div className="flex justify-end w-full">
          <Export campaign={campaign} />
        </div>
        <div className="grid grid-cols-4 gap-6">
          {users.map((user) => (
            <Card key={user._id} data={user} />
          ))}
        </div>
      </div>
      <div className="mt-5">
        <Pagination
          total={total}
          currentPage={filters.page}
          itemsPerPage={filters.perPage}
          onPageChange={(page) => {
            setFilters({ ...filters, page: page - 1 });
          }}
        />
      </div>
    </>
  );
};

const Card = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("PROFILE");
  const { name, avatar_url, company, location, login, blog, twitter_username } = data;

  return (
    <>
      <div onClick={() => setOpen(true)} className="bg-white p-4.5 shadow-card rounded-xl flex flex-col gap-y-4 hover:shadow-lg transition-shadow group cursor-pointer">
        <div className="aspect-square rounded-xl bg-[#CACDD8] overflow-hidden">
          <img src={avatar_url} alt={name} className="group-hover:scale-105 transition-transform w-full h-full object-cover" />
        </div>

        <div className="flex flex-col gap-y-4 justify-between flex-1">
          <div className="space-y-2.5 text-center">
            <p className="text-xl font-bold">{name || login}</p>
            {company && <p className="font-medium text-gray">{company}</p>}
            {location && (
              <div className="flex items-center gap-x-2 justify-center font-medium text-gray">
                <MdLocationPin />
                <p>{location}</p>
              </div>
            )}
          </div>

          <div className="flex items-center justify-center gap-x-2 text-2xl">
            {twitter_username && (
              <a href={`https://twitter.com/${twitter_username}`} target="_blank" className="hover:scale-105">
                <AiOutlineTwitter className="text-[#4597F7]" />
              </a>
            )}
            <a target="_blank" href={`https://github.com/${login}`} className="hover:scale-105">
              <AiFillGithub />
            </a>
            {blog && (
              <a target="_blank" href={blog} className="hover:scale-105">
                <BsGlobe className="text-gray text-xl" />
              </a>
            )}
          </div>
        </div>
      </div>

      {open && (
        <Modal title={name + "'s details"} isOpen={open} setIsOpen={() => setOpen(false)} className="rounded-2xl overflow-hidden relative bg-blue-10">
          <div>
            <p className="mb-2">{data.emails.join(", ")}</p>
            <div className="space-y-6">
              <div className="px-4 bg-white shadow-topbar space-x-8 rounded">
                <Tab active={tab === "PROFILE"} onClick={() => setTab("PROFILE")}>
                  Profile
                </Tab>
                <Tab active={tab === "STATS"} onClick={() => setTab("STATS")}>
                  Stats
                </Tab>
              </div>

              <div className="flex gap-x-4">
                {tab === "PROFILE" && <Profile data={data} />}
                {tab === "STATS" && <Stats data={data} />}
                <RightSection data={data} />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

const RightSection = ({ data }) => {
  console.log(data);

  const startDate = new Date(data.created_at);
  const experience = Math.floor((new Date() - startDate) / (1000 * 60 * 60 * 24 * 365));
  return (
    <div className="w-[30%] bg-white shadow-topbar rounded-xl divide-y divide-[#E5E7EB]">
      <div className="flex items-center justify-center flex-col gap-y-2 py-6">
        <div className="w-20 h-20 rounded-full border border-gray/20 overflow-hidden">
          <img src={data.avatar_url} alt={data.name || data.login} className="object-cover w-full h-full" />
        </div>
        <div className="text-center">
          <p className="font-bold text-xl text-gray">{data.name || data.login}</p>
          {data.company && <p className="font-medium text-gray">{data.company}</p>}
          {data.location && (
            <div className="flex items-center gap-x-2 justify-center font-medium text-gray">
              <MdLocationPin />
              <p>{data.location}</p>
            </div>
          )}
        </div>

        <div className="flex items-center justify-center gap-x-2.5">
          <p className="text-gray font-medium">
            <b>{data.followers} </b>
            Followers
          </p>
          <span className="w-1.5 h-1.5 rounded-full bg-gray" />
          <p className="text-gray font-medium">
            <b>{data.following} </b>
            Following
          </p>
        </div>
      </div>
      <div className="px-4.5 py-4">
        <p className="font-semibold">Experience</p>
        <p className="text-gray">{`${experience} years`}</p>
      </div>
      <div className="px-4.5 py-4">
        <p className="font-semibold">Forks</p>
        <p className="text-gray">-</p>
      </div>
      <div className="px-4.5 py-4">
        <p className="font-semibold">Hireable</p>
        <p className="text-gray">{data.hireable ? "Yes" : "No"}</p>
      </div>
      <div className="px-4.5 py-4">
        <p className="font-semibold">Public Repos</p>
        <p className="text-gray">{data.public_repos}</p>
      </div>
      <div className="px-4.5 py-4 space-y-2">
        <p className="font-semibold">Social proof</p>
        <div className="flex items-center gap-x-2 text-2xl">
          {data.twitter_username && (
            <a href={`https://twitter.com/${data.twitter_username}`} target="_blank">
              <AiOutlineTwitter className="text-[#4597F7]" />
            </a>
          )}
          <a href="#" target="_blank">
            <AiFillLinkedin className="text-[#3673AC]" />
          </a>
          <a target="_blank" href={`https://github.com/${data.login}`}>
            <AiFillGithub />
          </a>
          {data.blog && (
            <a target="_blank" href={data.blog}>
              <BsGlobe className="text-gray text-xl" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const Profile = ({ data }) => {
  if (!data.bio) return <div className="w-[70%] bg-white shadow-topbar p-4.5 rounded-xl h-full flex items-center justify-center">No data</div>;

  return (
    <div className="w-[70%] bg-white shadow-topbar p-4.5 rounded-xl">
      {data.bio && (
        <div className="space-y-4">
          <p className="font-bold">Bio</p>
          <div>{data.bio}</div>
        </div>
      )}
    </div>
  );
};

const Stats = ({ data }) => {
  const percentages = calculateLanguagePercentages(data.languages);
  const sortedPercentages = Object.entries(percentages).sort(([, percentageA], [, percentageB]) => parseFloat(percentageB) - parseFloat(percentageA));

  if (!data.languages.length) return <div className="w-[70%] bg-white shadow-topbar p-4.5 rounded-xl h-full flex items-center justify-center">No data</div>;

  return (
    <div className="w-[70%] bg-white shadow-topbar p-4.5 rounded-xl">
      <ul className="space-y-1">
        {sortedPercentages.map(([language, percentage]) => (
          <li key={language} className="flex items-center">
            <div className="w-[15%] flex items-center gap-x-2">
              <div className="w-6 h-6 shrink-0">
                <img src={fetchImage(getIconDetail(language)?.name)} />
              </div>
              <p className="font-semibold text-lg truncate">{language}</p>
            </div>
            <div className="bg-[#E1E1E1] flex-1 h-2.5 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${percentage}%`,
                  backgroundColor: getIconDetail(language)?.color || "#00000033",
                }}
              />
            </div>
            <p className="w-[6%] flex-none text-right text-gray">{percentage}%</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

function getIconDetail(lang) {
  const languange = lang.toLowerCase();
  const filteredIcons = IconsLib.filter((icon) => icon.name.includes(languange));
  if (filteredIcons.length > 0) {
    return filteredIcons[0];
  }
  return null;
}

function calculateLanguagePercentages(data) {
  const languageCount = {};

  data.forEach((language) => {
    if (languageCount[language]) {
      languageCount[language] += 1;
    } else {
      languageCount[language] = 1;
    }
  });

  const totalLanguages = data.length;

  const languagePercentages = {};
  for (const language in languageCount) {
    const count = languageCount[language];
    const percentage = (count / totalLanguages) * 100;
    languagePercentages[language] = percentage.toFixed(0);
  }

  return languagePercentages;
}

// to check if the image is exist
function fetchImage(language) {
  const [image, setImage] = useState("");

  useEffect(() => {
    (async () => {
      fetch(`https://cdn.jsdelivr.net/gh/devicons/devicon/icons/${language}/${language}-original.svg`).then((response) => setImage(response));
    })();
  }, [language]);

  if (!image.ok) return "https://cdn-icons-png.flaticon.com/24/2040/2040504.png";

  return image.url;
}
